import { enqueueSnackbar } from "notistack";
import {useEffect, useMemo} from "react";
import { useTranslation } from "react-i18next";
import { EXHIBITION } from "../../locales/components/namespaces";
import {useMessageTemplatesAction} from "./useMessageTemplatesAction";
import {useMessageTemplatesData} from "./useMessageTemplatesData";

const useMessageTemplate = (exhibitionId, dontFetchVariables = false, dontFetchTemplate = false, isCoorganization = false) => {
    const {t} = useTranslation(EXHIBITION)
    const {
        messageTemplateTypeId,
        loading: loadingMessageTemplate,
        messageTemplate,
        messageTemplateTypes,
        messageTemplateTypeVariables,
        messageToUser
    } = useMessageTemplatesData()
    const {
        getMessageTemplate,
        getMessageTemplateTypes,
        getMessageTemplateTypeVariables,
        updateMessageTemplate,
        setMessageToUser,
        setMessageTemplateTypeId
    } = useMessageTemplatesAction(exhibitionId)

    useEffect(() => {
        getMessageTemplateTypes(exhibitionId, isCoorganization)
    }, [exhibitionId, getMessageTemplateTypes, isCoorganization])

    useEffect(() => {
        if(!dontFetchVariables && messageTemplateTypeId !== '') {
            getMessageTemplateTypeVariables(messageTemplateTypeId)
        }
    }, [messageTemplateTypeId, getMessageTemplateTypeVariables, dontFetchVariables])

    useEffect(() => {
        if(!dontFetchTemplate && messageTemplateTypeId !== '') {
            getMessageTemplate(messageTemplateTypeId)
        }
    }, [dontFetchTemplate, getMessageTemplate, messageTemplateTypeId])
    
    useEffect(() => {
        if (messageToUser) {
            enqueueSnackbar(t(messageToUser?.text), {
                    variant: messageToUser?.variant
                }
            )
            setMessageToUser(null)
        }
    }, [messageToUser, setMessageToUser, t])

    const selectedMessageTemplateType = useMemo(() => {
        return messageTemplateTypes.find(f => f.id === messageTemplateTypeId)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [messageTemplateTypeId])

    const onChangeMessageTemplateType = (evt, fetchTemplate = true) => {
        const selectedTypeId = evt.target.value
        setMessageTemplateTypeId(selectedTypeId)
        if(fetchTemplate) {
            getMessageTemplate(selectedTypeId)
        }
    }

    const onSubmit = (values) => {
        updateMessageTemplate(values, messageTemplateTypeId)
    }

    return {
        loadingMessageTemplate,
        messageTemplateTypeId,
        selectedMessageTemplateType,
        messageTemplate,
        messageTemplateTypes,
        messageTemplateTypeVariables,
        onSubmit,
        onChangeMessageTemplateType
    }

}

export default useMessageTemplate